import { render, staticRenderFns } from "./MonEspace.vue?vue&type=template&id=d52b5218&lang=html"
import script from "./MonEspace.vue?vue&type=script&lang=js"
export * from "./MonEspace.vue?vue&type=script&lang=js"
import style0 from "./MonEspace.vue?vue&type=style&index=0&id=d52b5218&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports